import React from "react";
import ReactApexChart from "react-apexcharts";

const MultipleRadialbarsChart = ({ graph }) => {

  const chartData = {
    series: graph?.totalData || [],
    options: {
      chart: {
        type: "radialBar",
      },
      plotOptions: {
        radialBar: {
          dataLabels: {
            name: {
              fontSize: "22px",
            },
            value: {
              fontSize: "16px",
            },
            total: {
              show: true,
              label: "Total",
              formatter: (w) => {
                return w.globals.seriesTotals.reduce((a, b) => a + b, 0);
              },
            },
          },
        },
      },
      colors: graph?.categoryColor?.map(item => item?.color) ?? [],
      labels: graph?.totalCategory || [],
      legend: {
        show: true,
        position: "bottom",
        itemMargin: {
          vertical: 20,
        },
      },
    },
  };

  return (
    <div id="chart" className="p-0">
      <ReactApexChart
        options={chartData.options}
        series={chartData.series}
        type="radialBar"
        height={350}
      />
    </div>
  );
};

export default MultipleRadialbarsChart;
